import React from "react";
import T from "prop-types";
import { Modal } from "MODULES/shared/components";
import { Close, Header } from "MODULES/shared/components/Modal";
import api from "APP_ROOT/api";
import { useDispatch } from "APP_ROOT/hooks";
import { toastr } from "react-redux-toastr";
import { push } from "react-router-redux";
import Form from "./Form";

const MergePartModal = ({ close, open, partId }) => {
  const onSubmit = useCreateOnSubmit(partId, close);

  return (
    <Modal open={open} close={close} dialogClass="modal-sm">
      <Header>
        <Close close={close} />
        <h4 className="modal-title">Merge Parts</h4>
      </Header>
      <Form close={close} onSubmit={onSubmit} partId={partId} />
    </Modal>
  );
};

MergePartModal.propTypes = {
  close: T.func.isRequired,
  open: T.func.isRequired,
  partId: T.number.isRequired
};

export default MergePartModal;

// Custom hooks
function useCreateOnSubmit(partId, close) {
  const dispatch = useDispatch();
  const onSubmit = async formData => {
    const { data: part } = await api.parts.merge(partId, formData);
    toastr.success("Success", `${part.part_number} was successfully merged.`);
    close();
    dispatch(push({ pathname: `/parts/${part.id}` }));
  };

  return onSubmit;
}



// WEBPACK FOOTER //
// ./app/modules/parts/components/Detail/MergePartModal/MergePartModal.jsx